import {charcoal} from '../sass/base/_exports.sass';

export const SocialTTIcon = (props) => {
  const {color = charcoal, ratio = 1, className} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      className={className}
    >
      <path
        fill={color}
        d="M25.7619 7.41625C25.5594 7.31159 25.3623 7.19687 25.1712 7.0725C24.6158 6.70528 24.1065 6.27259 23.6544 5.78375C22.5231 4.48938 22.1006 3.17625 21.945 2.25688H21.9512C21.8212 1.49375 21.875 1 21.8831 1H16.7306V20.9237C16.7306 21.1912 16.7306 21.4556 16.7194 21.7169C16.7194 21.7494 16.7162 21.7794 16.7144 21.8144C16.7144 21.8288 16.7144 21.8438 16.7113 21.8587C16.7113 21.8625 16.7113 21.8663 16.7113 21.87C16.6569 22.5849 16.4278 23.2754 16.0439 23.8809C15.6601 24.4864 15.1333 24.9884 14.51 25.3425C13.8603 25.7121 13.1256 25.906 12.3781 25.905C9.9775 25.905 8.03187 23.9475 8.03187 21.53C8.03187 19.1125 9.9775 17.155 12.3781 17.155C12.8326 17.1546 13.2842 17.2261 13.7163 17.3669L13.7225 12.1206C12.4109 11.9512 11.0783 12.0554 9.80898 12.4268C8.53964 12.7981 7.36103 13.4285 6.3475 14.2781C5.45942 15.0498 4.7128 15.9704 4.14125 16.9988C3.92375 17.3738 3.10312 18.8806 3.00375 21.3263C2.94125 22.7144 3.35812 24.1525 3.55687 24.7469V24.7594C3.68187 25.1094 4.16625 26.3037 4.95562 27.3106C5.59215 28.1183 6.34418 28.8278 7.1875 29.4163V29.4037L7.2 29.4163C9.69437 31.1112 12.46 31 12.46 31C12.9388 30.9806 14.5425 31 16.3638 30.1369C18.3837 29.18 19.5337 27.7544 19.5337 27.7544C20.2684 26.9025 20.8526 25.9318 21.2612 24.8838C21.7275 23.6581 21.8831 22.1881 21.8831 21.6006V11.0306C21.9456 11.0681 22.7781 11.6187 22.7781 11.6187C22.7781 11.6187 23.9775 12.3875 25.8487 12.8881C27.1912 13.2444 29 13.3194 29 13.3194V8.20438C28.3662 8.27313 27.0794 8.07313 25.7619 7.41625Z"
      />
    </svg>
  );
};
